"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerBookingTable = void 0;
const isBefore_1 = __importDefault(require("date-fns/isBefore"));
const startOfToday_1 = __importDefault(require("date-fns/startOfToday"));
const react_1 = __importStar(require("react"));
const Badge_1 = __importDefault(require("react-bootstrap/Badge"));
const react_router_dom_1 = require("react-router-dom");
const react_table_1 = require("react-table");
const configContext_1 = require("../../context/configContext");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const NumericFormatTwoDecimals_1 = require("../numeric-format/NumericFormatTwoDecimals");
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
require("./ManagerTables.scss");
const ManagerBookingTable = (props) => {
    const config = (0, configContext_1.useConfig)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const columns = (0, react_1.useMemo)(() => {
        const cols = [];
        // First column is always the booking reference.
        cols.push({
            Header: "Referenz",
            accessor: (booking) => (react_1.default.createElement("span", { className: "text-nowrap" }, booking.reference)),
        });
        if (props.show.date) {
            cols.push({
                Header: "Datum",
                accessor: (booking) => (react_1.default.createElement("span", { className: "text-nowrap" },
                    dateUtils.WEEKDAYS_SHORT[booking.start.getDay()],
                    ",",
                    " ",
                    dateUtils.formatDate(booking.start))),
            });
        }
        if (props.show.startTime) {
            cols.push({
                Header: "von",
                accessor: (booking) => dateUtils.formatTime(booking.start),
            });
        }
        if (props.show.endTime) {
            cols.push({
                Header: "bis",
                accessor: (booking) => dateUtils.formatTime(booking.end),
            });
        }
        if (props.show.resource) {
            cols.push({
                Header: "Ressource",
                accessor: (booking) => {
                    const configResource = config.getResourceById(booking.getResourceId());
                    return (react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: configResource !== null && configResource !== void 0 ? configResource : booking.getResourceId() }));
                },
            });
        }
        if (props.show.title) {
            cols.push({
                Header: "Titel",
                accessor: (booking) => booking.title,
            });
        }
        if (props.show.subtitle) {
            cols.push({
                Header: "Untertitel",
                accessor: (booking) => booking.subtitle,
            });
        }
        if (props.show.contactName) {
            cols.push({
                Header: "Kontaktperson",
                accessor: (booking) => booking instanceof CustomerBooking_1.CustomerBooking ? booking.contact.name : "",
            });
        }
        if (props.show.contactOrg) {
            cols.push({
                Header: "Organisation",
                accessor: (booking) => booking instanceof CustomerBooking_1.CustomerBooking ? booking.contact.org : "",
            });
        }
        if (props.show.created) {
            cols.push({
                Header: "Erstellt",
                accessor: (booking) => booking.created ? dateUtils.formatDate(booking.created) : "",
            });
        }
        if (props.show.bookingStatus) {
            cols.push({
                Header: "Buchungsstatus",
                accessor: (booking) => {
                    if (booking instanceof CustomerBooking_1.CustomerBooking) {
                        // Only CustomerBooking has a relevant booking status.
                        return booking.status.nameDe;
                    }
                    else {
                        return (react_1.default.createElement("span", { className: "small italics text-nowrap" }, "kein Kunde"));
                    }
                },
            });
        }
        if (props.show.invoiceStatus) {
            cols.push({
                Header: "Rechnungsstatus",
                accessor: (booking) => {
                    if (booking instanceof CustomerBooking_1.CustomerBooking) {
                        return (react_1.default.createElement(Badge_1.default, { variant: "dark", className: `status-${booking.invoiceStatus.name}-bg` }, booking.invoiceStatus.nameDe));
                    }
                    else {
                        return react_1.default.createElement("span", { className: "small italics text-nowrap" }, "---");
                    }
                },
            });
        }
        if (props.show.invoiceDate) {
            cols.push({
                Header: "Rechnungsdatum",
                accessor: (booking) => booking instanceof CustomerBooking_1.CustomerBooking
                    ? booking.invoiceDate
                        ? dateUtils.formatDate(booking.invoiceDate)
                        : ""
                    : "",
            });
        }
        if (props.show.dueDate) {
            cols.push({
                Header: "Zahlbar bis",
                accessor: (booking) => {
                    if (booking instanceof CustomerBooking_1.CustomerBooking && booking.dueDate) {
                        if ((0, isBefore_1.default)(booking.dueDate, (0, startOfToday_1.default)())) {
                            return (react_1.default.createElement("span", { className: "text-danger" }, dateUtils.formatDate(booking.dueDate)));
                        }
                        else {
                            return dateUtils.formatDate(booking.dueDate);
                        }
                    }
                    return "";
                },
            });
        }
        if (props.show.balance) {
            cols.push({
                Header: "Offener Betrag",
                accessor: (booking) => booking instanceof CustomerBooking_1.CustomerBooking ? (react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { className: "text-right d-block", value: booking.calcTotals().outstandingBalance })) : (""),
            });
        }
        return cols;
    }, []);
    // Init table.
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = (0, react_table_1.useTable)({
        columns,
        data: props.bookings,
    });
    function handleRowClick(booking) {
        navigate(`/manager/${config.tenantId}/bookings/${booking.reference}/`);
    }
    return (react_1.default.createElement("div", { className: "manager-table table-responsive" },
        react_1.default.createElement("table", { ...getTableProps(), id: "table", className: "table table-sm table-striped table-hover sticky-header" },
            react_1.default.createElement("thead", null, headerGroups.map((headerGroup) => (react_1.default.createElement("tr", { ...headerGroup.getHeaderGroupProps() }, headerGroup.headers.map((column) => (react_1.default.createElement("th", { ...column.getHeaderProps() }, column.render("Header")))))))),
            react_1.default.createElement("tbody", { ...getTableBodyProps() }, rows.map((row, i) => {
                prepareRow(row);
                return (react_1.default.createElement("tr", { ...row.getRowProps(), onClick: () => handleRowClick(row.original) }, row.cells.map((cell) => {
                    return (react_1.default.createElement("td", { ...cell.getCellProps() }, cell.render("Cell")));
                })));
            }))),
        props.bookings.length === 0 && (react_1.default.createElement("div", { className: "text-center text-secondary" }, "Keine Daten"))));
};
exports.ManagerBookingTable = ManagerBookingTable;
